import { render, staticRenderFns } from "./Associations.vue?vue&type=template&id=5d20666c&scoped=true"
import script from "./Associations.vue?vue&type=script&lang=js"
export * from "./Associations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d20666c",
  null
  
)

export default component.exports